import { Pipe, PipeTransform } from '@angular/core';
import { BooleanFilter, Filter, FilterTypes } from '@models/filter-types';

@Pipe({
    name: 'isBooleanFilter',
    standalone: false,
})
export class IsBooleanFilterPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: Filter<any>): value is BooleanFilter {
        return value?.Type === FilterTypes.BooleanFilterType;
    }
}
